import React from 'react'

const LoadingSpinner = ({
  size = 'md',
  className = '',
  color = 'primary',
  text = null
}) => {
  const sizePx = {
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
  }

  const borderColor = {
    primary: 'var(--accent)',
    accent:  'var(--accent)',
    white:   '#ffffff',
    neutral: 'var(--text-muted)',
  }

  const dim = sizePx[size] || sizePx.md
  const color_ = borderColor[color] || borderColor.primary

  return (
    <div className={['flex items-center justify-center', className].filter(Boolean).join(' ')}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
        <div
          style={{
            width: dim,
            height: dim,
            border: '2px solid var(--border)',
            borderTopColor: color_,
            borderRadius: '50%',
            animation: 'spin 0.7s linear infinite',
          }}
        />
        {text && (
          <p className="text-muted" style={{ fontSize: '0.875rem' }}>{text}</p>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner
